"use client";

import Link from "next/link";
import { useFormState, useFormStatus } from 'react-dom';
import { recover_password } from '@/app/lib/actions';
import {useForm} from "react-hook-form";
import { zfd } from "zod-form-data";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const formSchema = zfd.formData(
  z.object({
      email: zfd.text(z.string().email())
  })
)

const initialState = {
  message: '',
}


export default function RecoveryForm () {
    const [state, formAction] = useFormState(recover_password, initialState);

    const {register, formState: {isValid, errors}} = useForm({
      mode: "all",
      resolver: zodResolver(formSchema)
  });
    return (
        <>
            <form action={formAction} className="pt-5">
                  <div>
                    <p className="text-black alt-font fw-bold fs-2  mb-[30px]">Password Recovery</p>
                    <p className="text-sm ">Enter your email and we will send you instructions to reset your password</p>

                  </div>

                  <div className="pt-5">
                    <div className="space-y-2">
                      <div>
                        <label className="">Email</label>
                        <input 
                        {...register("email")}
                        type="email"
                        className={classNames(!errors.email ? ""  : "is-invalid","form-control")}></input>
                      </div>
                    </div>

                  </div>

                  <p aria-live="polite" className={`${!state?.success &&  state?.message ? "text-danger" : "text-success" } `}>
                      {state?.message}
                  </p>

                  <div className="pt-10">
                    <div>
                      <SubmitButton isValid={isValid}/>
                    </div>
                  </div>

                  
            </form>
        </>
    )
}

function SubmitButton({isValid}) {
    const { pending } = useFormStatus();
   
    return (
        <>
            <button 
                type="submit"
                disabled={pending} 
                className="w-full py-2 px-4 space-x-2 bg-black text-white font-semibold rounded">
                <span>
                    {pending ? "LOADING ..." : "RECOVER PASSWORD"}
                </span>
            </button>
        </>
    );
  }